module.exports = __webpack_public_path__ + "img/warning-2.5ba94f46.png";